const wrapAll = (
  productItem,
  targetClasses,
  parentClass,
  requiredClass = "required-class"
) => {
  //console.log("product item =", productItem);
  //console.log("target class=", targetClasses);
  //console.log("parent class=",parentClass);
  if (!productItem) return;
  let parent = productItem.querySelector(parentClass);
  //console.log("parent=",parent);
  if (!parent) return;
  let wrapper = document.createElement("div");
  wrapper.classList.add(requiredClass);

  if (productItem.getElementsByClassName(requiredClass).length === 0) {
    for (let targetClass of targetClasses) {
      let target = productItem.querySelectorAll(targetClass);
      //console.log("target match=", target);
      if (!target) continue;
      target.forEach((child) => wrapper.append(child));
    }
    parent.append(wrapper);
  } else {
    for (let targetClass of targetClasses) {
      let target = productItem.querySelectorAll(targetClass);
      //console.log("target ", target);
      if (!target) continue;
      target.forEach((child) =>
        productItem.querySelector("." + requiredClass).append(child)
      );
    }
  }

  // Check if specsheet exists and move it after the inventory status
  // const specsheet = document.querySelector(".specsheet-parent");
  // const inventoryStatus = document.querySelector(".boost-sd__inventory-status");
  // console.log(inventoryStatus);

  // if (specsheet && inventoryStatus) {
  //   inventoryStatus.after(specsheet);
  // }

  //console.log("wrapper=",wrapper);
  return wrapper;
};
const customize = {
  updateProductItem: (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductImage", {
      name: "Modify Images",
      enabled: true,
      apply: () => ({
        // Approach 1 change props
        props: (props) => {
          props.deviceSizes = [400, 500, 600, 700, 800];
          return props;
        },
      }),
    });
    componentRegistry.useModulePlugin("CartAPI", {
      name: "Integrate theme cart",
      apply(builder) {
        builder.on("methodFulfilled", "addToCart", async (payload) => {
          let cartDrawer = document.querySelector("cart-drawer");
          let sectionsId =
            cartDrawer
              .closest(".shopify-section")
              .id.replace("shopify-section-", "") + ",cart-icon-bubble";
          let sectionsHTML = await fetch("/?sections=" + sectionsId).then(
            (data) => data.json()
          );
          let existingCart = await fetch("/cart.js").then((data) =>
            data.json()
          );
          let existingCartWithSections = {
            ...existingCart,
            sections: sectionsHTML,
          };
          cartDrawer.renderContents(existingCartWithSections, true);

          return payload;
        });
      },
    });
    componentRegistry.useComponentPlugin("ProductItem", {
      name: "Add SKU and specsheet to product card",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            // Add custom wrapper to every product item
            let productData = element.getParams().props.product;
            //console.log("data=", productData);
            let productId = productData.id;
            if (productData.variant_id) {
              productId = productData.variant_id;
            }
            let productItems = document.querySelectorAll(
              '[data-product-id="' + productId + '"]'
            );
            //console.log("product items =", productItems);
            for (let productItem of productItems) {
             wrapAll(
               productItem,
               [
                 ".boost-sd__product-info .boost-sd__product-price",
                 ".boost-sd__product-info .boost-sd__inventory-status",
                 ".specsheet-parent",
                 ".boost-sd__product-info .boost-sd__button",
               ],
               ".boost-sd__product-link:not(.boost-sd__product-link-image) .boost-sd__product-info",
               "boost-sd__atc-wl-wrapper"
             );
            }
            updateStyling(element);
          } catch (e) {
            console.error(e);
          }
          try {
            addSpecsheet(element);
          } catch (e) {
            console.error(e);
          }
          try {
            addBasicSubtitle(element);
          } catch (e) {
            console.error(e);
          }
        },
      }),
    }),
      componentRegistry.useComponentPlugin("ProductItemListViewLayout", {
        name: "Add SKU and specsheet to product card (list view)",
        enabled: true,
        apply: () => ({
          afterRender(element) {
            try {
              let productData = element.getParams().props.product;
              let productItem = document.querySelector(
                '[data-product-id="' + productData.id + '"]'
              );

              // Add inventory status
              let inventoryCount =
                productData?.variants[0]?.inventory_quantity || 0;
              let invertoryStatus =
                inventoryCount > 0
                  ? `In stock (${inventoryCount} ${
                      inventoryCount > 1 ? "units" : "unit"
                    })`
                  : "On Backorder";
              let inventoryStatusHTML =
                '<span class="boost-sd__inventory-status" style="color: rgb(0, 164, 124)">' +
                invertoryStatus +
                "</span>";
              if (
                productItem &&
                !productItem.querySelector(".boost-sd__inventory-status") &&
                productItem?.querySelector(
                  ".boost-sd__product-item-list-view-layout-price"
                )
              ) {
                productItem
                  .querySelector(
                    ".boost-sd__product-item-list-view-layout-price"
                  )
                  .insertAdjacentHTML("afterend", inventoryStatusHTML);
              }

              if (productItem) {
                productItem.querySelector(
                  ".boost-sd__product-title"
                ).innerHTML = productData.title;
              }

              try {
                updateStyling(element);
              } catch (e) {}
              try {
                addSpecsheet(element);
              } catch (e) {}
              try {
                addBasicSubtitle(element);
              } catch (e) {}
            } catch (e) {
              console.error(e);
            }
          },
        }),
      }),
      componentRegistry.useComponentPlugin("FilterOption", {
        name: "FilterOption - Customize sorting",
        apply: () => ({
          props: (props) => {
            // can custom for any Filter Option check props to customize for special FilterOption
            let ids = [
              "pf_t_voltage_v",
              "pf_t_current_a",
              "pf_t_output_voltage_v",
              "pf_t_current_ma",
            ];
            if (ids.includes(props.option.filterOptionId)) {
              props.customizeSorting = (values) => {
                // change logic sorting
                let newValues = values.map((e) => {
                  e.new_key = e.key.replace(/^\D+/g, "");
                  return e;
                });
                return values.sort((a, b) => a.new_key - b.new_key);
              };
            }

            return props;
          },
        }),
      });

    let preventReCallProductHandlesTheSame = [];
    let customizeProductsData = [];
    // call get data
    const updateProductList = {
      name: "ProductList - Shopify Ajax update",
      apply() {
        return {
          async afterRender(element) {
            console.log("after render product list run !!!");
            const helpersRef = element.getHelpers();

            // Function get all handles displayed in product list
            const productHandles = helpersRef.getProductHandles();

            // Check duplicate not call. prevent call multi the same value
            const isDuplicate =
              JSON.stringify(preventReCallProductHandlesTheSame) ===
              JSON.stringify(productHandles);

            preventReCallProductHandlesTheSame = productHandles;
            if (productHandles?.length && !isDuplicate) {
              // (optional) set Loading when calling Ajax
              helpersRef.setAjaxLoading(true);

              const products = await helpersRef.getProductListHtmlByAjax(
                true,
                productHandles,
                "boost-sd-integration",
                20
              );
              customizeProductsData = products;
              // (optional) off Loading when called Ajax
              helpersRef.setAjaxLoading(false);
            }
          },
        };
      },
    };

    // find and apply for productItem type List
    const updateProductItemListView = {
      name: "ProductItemListView - Shopify Ajax update",
      apply() {
        return {
          afterRender(element) {
            customizeProductsData.forEach((element) => {
              const productItem = document.querySelector(
                `.boost-sd__product-item-list-view-layout[id='${element.id}']`
              );
              // use: querySelector
              if (productItem) {
                const replaceElement = productItem.querySelector(
                  ".boost-sd__product-item-list-view-layout-price"
                );
                if (replaceElement) {
                  replaceElement.innerHTML = element.custom_html;
                }
              }
            });
          },
        };
      },
    };

    // find and apply for productItem type Grid
    const updateProductItemGridView = {
      name: "ProductItemGridView - Shopify Ajax update",
      apply() {
        return {
          afterRender(element) {
            customizeProductsData.forEach((element) => {
              const productItem = document.querySelector(
                `.boost-sd__product-item[id='${element.id}']`
              );
              // use: querySelector
              if (productItem) {
                const replaceElement = productItem.querySelector(
                  ".boost-sd__product-price"
                );
                if (replaceElement) {
                  replaceElement.innerHTML = element.custom_html;
                }
              }
            });
          },
        };
      },
    };
    const updateSearchProductList = {
      name: "update Search Product List - Shopify Ajax update",
      apply() {
        return {
          afterRender(element) {
            const helpersRef = element.getHelpers();
            const {
              props: { products },
            } = element.getParams();
            if (products?.length > 0) {
              const productHandle = products.map((product) => product.handle);
              console.log(element);
            }
          },
        };
      },
    };

    // Register updateProductList When ProductList rendered
    componentRegistry.useComponentPlugin(
      "SearchProductList",
      updateSearchProductList
    );
    componentRegistry.useComponentPlugin("ProductList", updateProductList);
    componentRegistry.useComponentPlugin(
      "ProductItemListViewLayout",
      updateProductItemListView
    );
    componentRegistry.useComponentPlugin(
      "ProductItemWidget",
      updateProductItemGridView
    );
  },
};

function updateStyling(element) {
  let productData = element.getParams().props.product;
  let productItem = document.querySelector(
    '[data-product-id="' + productData.id + '"]'
  );
  let inventoryStatusSpan = productItem?.querySelector(
    ".boost-sd__inventory-status"
  );
  let addToCartBtnText = productItem?.querySelector(".boost-sd__button-text");

  if (productData.variants[0].inventory_quantity == 0 && inventoryStatusSpan) {
    inventoryStatusSpan.style.color = "gray";
    inventoryStatusSpan.textContent = "On Backorder";
    addToCartBtnText.textContent = "Backorder";
  }
}

function addSpecsheet(element) {
  let productData = element.getParams().props.product;
  let productItem = document.querySelector(
    '[data-product-id="' + productData.id + '"]'
  );
  let inventoryStatusSpan = productItem?.querySelector(
    ".boost-sd__inventory-status"
  );

  let specsheetMetafield = productData.metafields.find(
    (meta) => meta.key == "filejson"
  );
  let existingSpecsheet = productItem?.querySelector(".specsheet-parent");

  if (!specsheetMetafield && !existingSpecsheet) {
      inventoryStatusSpan.insertAdjacentHTML(
        "afterend",
        '<div class="caption-with-letter-spacing light specsheet-parent" style="color: transparent;">Spec Sheet</div>'
      );
      return;
  }

  let specsheetJSON = JSON.parse(specsheetMetafield.value)[0];
  let specsheetURL = specsheetJSON.content[0].url;
  //console.log('product=', productItem);
  //console.log('existing=', existingSpecsheet);

  if (!existingSpecsheet) {
    let elementHTML = `
                      <div class="caption-with-letter-spacing light specsheet-parent">
                        <a style="text-decoration:none;color:gray;" class="specsheet" href="${specsheetURL}"
                        download="${productData.skus[0]}"
                        target="_blank">
                          ${
                            specsheetURL
                              ? '<i class="fa fa-download" aria-hidden="true"></i>\n Spec Sheet'
                              : ""
                          }
                        </a>
                      </div>`;
    inventoryStatusSpan &&
      inventoryStatusSpan.after(createElementFromHTML(elementHTML));
  }
}
function addBasicSubtitle(element) {
  let productData = element.getParams().props.product;
  let productItem = document.querySelector(
    '[data-product-id="' + productData.id + '"]'
  );
  let productTitleElement = productItem?.querySelector(
    ".boost-sd__product-title"
  );
  let basicSubtitleMetafield = productData.metafields.find(
    (meta) => meta.key == "subtitle" && meta.namespace == "basic"
  );
  if (!basicSubtitleMetafield) return "";

  let existingBasicSubtitle = productItem?.querySelector(".basic-subtitle");

  if (!existingBasicSubtitle) {
    let elementHTML = `
                      <div class="caption-with-letter-spacing light basic-subtitle">
                        ${basicSubtitleMetafield?.value}
                      </div>`;
    productTitleElement &&
      productTitleElement.after(createElementFromHTML(elementHTML));
  }
}

function createElementFromHTML(htmlString) {
  var div = document.createElement("div");
  div.innerHTML = htmlString.trim();

  // Change this to div.childNodes to support multiple top-level nodes.

  return div.firstChild;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.updateProductItem,
]);
